// --------------------------------------------- RESPONSE MESSAGE

//SUCCESS
export const SUCCESS_MESSAGE_CREATE = 'Se creó con éxito'
export const SUCCESS_MESSAGE_UPDATE = 'Se actualizó el registro correctamente'
export const SUCCESS_MESSAGE_DELETE = 'Se eliminó con éxito'
export const SUCCESS_MESSAGE_DOWNLOAD = 'Se descargó correctamente'

//ERROR
export const ERROR_MESSAGE_SYSTEM = 'Error interno'
export const ERROR_MESSAGE_DELETE = 'Se eliminó con éxito'

// -------------------------------- VALOR ID DE PAIS

export const valueIdCountry = 'o5AlV8Cm_Mw='
